import React from 'react';
import TextField from '@material-ui/core/TextField';
import BasicLabel from '../BasicLabel/BasicLabel';
import './DateTimeField.scss';
import { formatToDateTimeLocal } from '../../../Common/Helper';

export default class DateTimeField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mandatoryWarning: "Please complete this mandatory field",
    };
  }

  render() {
    const {
      value,
      label,
      isMandatory,
      disabled,
      id,
      onChange,
      showMandatory,
      showErrorBorder,
    } = this.props;

    // Convert the incoming value (local time string) to datetime-local input format
    const dateTimeValue = value ? formatToDateTimeLocal(value) : "";

    const error = (showMandatory && !dateTimeValue) || showErrorBorder || false;

    return (
      <div className={`${error ? "DateTimeFieldContainer error" : "DateTimeFieldContainer"}`}>
        {label && (
          <BasicLabel
            text={label}
            type="text"
            isMandatory={isMandatory || false}
          />
        )}
        <TextField
          type="datetime-local"
          id={id}
          variant="outlined"
          disabled={disabled || false}
          value={dateTimeValue}
          onChange={onChange}
          InputLabelProps={{ shrink: true }}
        />
        {error && (
          <div className="errorText">
            {showMandatory && !dateTimeValue ? this.state.mandatoryWarning : ""}
          </div>
        )}
      </div>
    );
  }
}
